import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { generateRandomString } from "utils/helper";
import * as services from "../services/socialSecurityContributionApi";
import { setCurrentSocialSecurityContribution, setIsLoading } from "../slices/socialSecurityContributionSlice";

function useSocialSecurityContributionView(props) {
  const { onEdit = () => { } } = props;
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.socialSecurityContribution.isLoading);
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const currentSocialSecurityContribution = useSelector(
    (state) => state.socialSecurityContribution.currentSocialSecurityContribution
  );

  const getSocialSecurityContribution = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await services.getSocialSecurityRate({
        requestId: generateRandomString(),
        companyId: currentCompany,
      });
      dispatch(setCurrentSocialSecurityContribution(response.data));
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch]);

  useEffect(() => {
    if (currentCompany && typeof currentCompany !== "object") {
      getSocialSecurityContribution();
    }
  }, [currentCompany, getSocialSecurityContribution]);

  return { isLoading, currentSocialSecurityContribution, onEdit };
}

export default useSocialSecurityContributionView;
